
<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <div>
    <b-card title="Informations générales">
      <b-row>
        <b-col
          md="6"
          xl="4"
          class="mb-1"
        >
          <b-form-group
            label="Nom"
            label-for="basicInput"
          >
            <b-form-input
             required
              id="basicInput"
              v-model="form.name"
              :plaintext="readOnly"
              placeholder="Nom"
            />
          </b-form-group>

          <b-form-group
              label="Ordre d'affichage"
              label-for="Ordre d'affichage"
            >
           
            
              <b-form-input
                id="Ordre d'affichage"
                v-model="form.order_display"
                :plaintext="readOnly"
                type="number"
                step="1"
                placeholder="Ordre d'affichage"
               
              />
             
            </b-form-group>
            
        </b-col>
      </b-row>

    </b-card>

    <b-button v-if="edition==false"
     @click="createTintCategory"
    >
    Enregistrer
    </b-button>

    <b-button v-else
     @click="editTintCategory"
    >
    Enregistrer
    </b-button>

  </div>
</b-overlay>
</template>

<script>
import { BButton,BFormInput,BOverlay, BRow, BCol, BFormGroup,BFormFile, BCard, BFormCheckbox, BFormTextarea} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import {APIRequest} from '@simb2s/senseye-sdk'

export default {
  name: 'TintStyleForm',
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BFormFile,
    BOverlay,
    BCard,
    BFormCheckbox,
    BFormTextarea,
    vSelect
  },
  data() {
      return {
          edition:false,
          loading:true,
          currentBase64:null,
          file: null,
          form:{
            name:"",
            file:'',
            price:0,
            order_display:null,
            photo:''
          },
      }
  },
  props: ['tint_style', 'readOnly'],
  methods:{
    async createTintCategory()
    {
      this.loading=true
      try {
       
        await APIRequest.create('tint-styles',this.form)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Le style de teinte a bien été créé !',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.$router.push({name:'tint-styles'})
      } catch (error) {
        this.loading=false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Une erreur est survenue.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        
      }
      
    },
    async editTintCategory()
    {
      this.loading=true
      try {
       
        await APIRequest.update('tint-styles',this.tint_style.id,this.form)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Le style de teinte a bien été modifié !',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.$router.push({name:'tint-styles'})
      } catch (error) {
        this.loading=false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Une erreur est survenue.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        
      }
      
    },
 
  },

  
    
  async mounted(){
   if(this.tint_style!=null)
    {
        this.form.name = this.tint_style.name
      this.form.price = this.tint_style.price
      this.form.photo = this.tint_style.photo
      this.form.file = this.tint_style.file
      this.form.order_display = this.tint_style.order_display

      this.edition=true
    }
    this.loading=false
  }

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>